import { upperCaseFirstAll } from '../string/upper_case_first_all';
import { upperCaseMaxLengthWords } from '../string/upper_case_max_length_words';

export function formatFilterDefaultLabel(label, options = {}) {
    if (options.upperCaseFirstAll) {
        return formatFilterDefaultLabel(
            upperCaseFirstAll( label ),
            { ...options, upperCaseFirstAll: false }
        );
    }

    if (options.upperCaseMaxLengthWords) {
        return formatFilterDefaultLabel(
            upperCaseMaxLengthWords( label, 3 ),
            { ...options, upperCaseMaxLengthWords: false }
        );
    }

    return label;
}
